import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "featureId", "featureCategoryId", "onClick", "tooltip", "usageTracker", "usageTrackerAppLocationKey", "eventName", "eventProperties"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { useTracker } from '../../hooks/useTracker';
import { AIBaseIconButton } from './internal/AIBaseIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const AIIconButton = _ref => {
  let {
      children,
      featureId,
      featureCategoryId,
      onClick,
      tooltip,
      usageTracker,
      usageTrackerAppLocationKey,
      eventName,
      eventProperties
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    aiTracker,
    legacyTracker
  } = useTracker(usageTracker, usageTrackerAppLocationKey);
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      if (aiTracker) {
        aiTracker.track('Ai Components Ui Library', 'Aibuttoninteraction', {
          type: 'icon - trigger',
          featureId,
          featureCategoryId
        });
        // Custom tracking
        if (eventName && eventProperties && legacyTracker) {
          legacyTracker.track(eventName, eventProperties);
        }
      }
    }
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: tooltip,
    children: /*#__PURE__*/_jsx(AIBaseIconButton, Object.assign({}, props, {
      "data-test-id": props['data-test-id'] || 'ai-icon-button',
      onClick: handleClick,
      children: children
    }))
  });
};
AIIconButton.displayName = 'AIIconButton';
export default AIIconButton;